import {
  fetchAll,
  fetchFiltered,
  add,
  edit,
  show
} from '@/api/movementtype'

const state = {
  all: [],
  isLoading: false,
  movementTypeById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const movementType = await show(id)
      commit('setMovementTypeById', movementType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const movementTypes = await fetchAll()
      commit('setAll', movementTypes)
    } catch (e) {
      dispatch('notify/success', e.message, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const movementTypes = await fetchFiltered(queriesParams)
      commit('setAll', movementTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, movementType) {
    commit('setLoading', true)
    try {
      await add(movementType)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.movementTypeById = null
  },

  setMovementTypeById (state, movementType) {
    state.movementTypeById = movementType
  },

  setAll (state, movementTypes) {
    state.all = movementTypes
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}